<template>
  <div>
    <div v-if="data_is_loading" class="table-loading-overlay">
      <b-spinner variant="primary" />
    </div>
    <tr v-for="ip in ips" :key="ip.id" class="row-ips">
      <td class="w-20">–</td>
      <td class="w-15">{{ ip.ip }}</td>
      <td class="w-15">{{ server }}</td>
      <td class="w-15">{{ ip.prefix ? ip.prefix : '–' }}</td>
      <td class="w-5">–</td>
      <td class="w-10">–</td>
      <td class="w-10">–</td>
      <td class="w-10 table-actions">
        <img v-if="!ip.is_main" title="Remove IP" class="remove-ips" src="/img/icons/table-controls/close.svg" @click="delete_ip(id, ip.id)" />
      </td>
    </tr>
  </div>
</template>

<script>
  import { TrunkService } from '@voice/services/TrunkService';

  export default {
    props: {
      id: {
        type: Number,
        default: null
      },

      server: {
        type: String,
        default: null
      }
    },

    data: () => ({
      data_is_loading: true,
      ips: []
    }),

    mounted() {
      if (this.id) this.get_more_ips(this.id);
    },

    methods: {
      get_more_ips: function(id) {
        return TrunkService.getMoreIps(id)
          .then(resp => {
            this.ips = resp.data.filter(item => !item.is_main);
            this.data_is_loading = false;
          })
          .catch(error => console.log(error));
      },

      delete_ip(trunk_id, ip_id) {
        this.data_is_loading = true;
        return TrunkService.removeIpFromIps(trunk_id, ip_id)
          .then(() => {
            this.get_more_ips(this.id);
          })
          .catch(error => {
            this.$noty.server_error(error);
            console.log(error);
          });
      }
    }
  }
</script>

<style lang="scss">
  .b-table-details,
  .b-table-details > td,
  .b-table-details > td > div {
    display: contents;
  }

  .b-table-details > td {
    padding: 0;
  }

  .remove-ips {
    cursor: pointer;
  }
</style>
